export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ff53ee8673c4ab4cc64a27322fd1d723.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40 z-0"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8">
            <span className="text-sm text-white font-medium">Enterprise VPN Solution</span>
          </div>
          
          <h2 className="text-6xl md:text-7xl font-black text-white mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Secure Your
            <br />
            <span className="ml-8">Digital</span>
            <br />
            <span className="ml-16">Privacy</span>
          </h2>
          
          <p className="text-xl text-white/90 mb-10 max-w-2xl leading-relaxed">
            Professional VPN application providing military-grade encryption and complete online anonymity for individuals and businesses.
          </p>
          
          <div className="flex flex-wrap gap-4 mb-8">
            <button 
              onClick={scrollToContact}
              className="px-8 py-4 bg-white text-gray-900 rounded-xl font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Start Free Trial
            </button>
            <button 
              onClick={scrollToContact}
              className="px-8 py-4 bg-transparent text-white border-2 border-white rounded-xl font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Learn More
            </button>
          </div>
          
          <a 
            href="mailto:contact@brzoglasdoo.com"
            className="inline-block text-white/80 hover:text-white transition-colors font-mono text-sm"
          >
            contact@brzoglasdoo.com
          </a>
        </div>
      </div>
    </section>
  );
}
